import React, { useState } from 'react';
import Picker from 'emoji-picker-react';
import { Grid, IconButton, makeStyles, TextField, Tooltip, Typography } from '@material-ui/core';
import { negativeC, primaryB } from 'constants/colors';
import PropTypes from 'prop-types';
import MoodIcon from '@material-ui/icons/Mood';
import SendIcon from '@material-ui/icons/Send';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingRight: 144,
  },
}));

const AsterEmojiTextField = ({ InputProps, setValue, disabled, fullWidth, label, placeholder, error, helperText, photos, handleSend, setOpen, loading, noData, ...props }) => {
  const classes = useStyles();
  const [bar, setBar] = useState(false);

  const onEmojiClick = (event, emojiObject) => {
    setValue(emojiObject);
    setBar(false);
  };

  return (
    <Grid style={{ position: 'relative' }} onKeyPress={(e) => e.key === 'Enter' && !loading && handleSend()}>
      <TextField
        fullWidth={fullWidth}
        label={label}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        InputProps={{
          classes: {
            root: classes.root,
          },
          disableUnderline: true,
          ...InputProps,
        }}
        {...props}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Grid
        style={{
          position: 'absolute',
          right: 0,
          top: !!label ? 23 : -1,
        }}
      >
        <Tooltip title={'Добавить эмодзи'}>
          <IconButton color={'primary'} onClick={() => setBar(!bar)} disabled={disabled}>
            <MoodIcon style={{ color: primaryB }} />
          </IconButton>
        </Tooltip>
        <Tooltip title={'Прикрепить файл'}>
          <IconButton color={'primary'} onClick={() => setOpen(true)} style={{ position: 'relative' }}>
            <AttachFileIcon style={{ color: primaryB }} />
            {!!photos.length && (
              <Typography
                style={{
                  position: 'absolute',
                  textAlign: 'center',
                  right: 0,
                  top: 0,
                  fontSize: 11,
                  height: 15,
                  width: 15,
                  borderRadius: 8,
                  background: negativeC,
                  color: '#FFF',
                }}
              >
                {photos.length}
              </Typography>
            )}
          </IconButton>
        </Tooltip>
        {!noData && (
          <Tooltip title={'Отправить комментарий'}>
            <IconButton color={'primary'} onClick={handleSend} disabled={!!loading}>
              <SendIcon style={{ color: primaryB }} />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      {!!bar && (
        <>
          <Picker
            onEmojiClick={onEmojiClick}
            disableSearchBar
            disableSkinTonePicker
            pickerStyle={{
              position: 'absolute',
              zIndex: 200,
              right: 0,
              width: '100%',
              bottom: !!label ? '70%' : '110%',
            }}
          />
          <Grid style={{ position: 'fixed', zIndex: 199, width: '100vw', height: '100vh', top: 0, left: 0 }} onClick={() => setBar(!bar)} />
        </>
      )}
    </Grid>
  );
};
export default AsterEmojiTextField;
AsterEmojiTextField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setValue: PropTypes.func,
  type: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
};
